module.exports = __webpack_public_path__ + "static/banner-mobile-ae18d6994de1ba900230cb2c9b6562be.png";